export default "<p>\r\n  church-details-times works!\r\n</p>\r\n"